<template>
  <div class="w100 bg-w pt20 pb20 pl20 pr20">
    <p class="w100 font-16">车辆信息管理</p>
    <div class="w100 pt10 pb20 cl-f">
      <div class="fr">
        关键字：
        <el-input class="mr10" style="width: 190px;" clearable v-model="queryKey" placeholder="可输入车牌号查询"></el-input>
        <el-button type="primary" @click="page = 1, fetchList()" :loading="loading">查询</el-button>
        <el-button type="warning" :loading="loading" @click="showAdd">新增</el-button>
      </div>
    </div>

    <el-table class="w100" :data="list" stripe border height="550">
      <el-table-column align="center" label="车牌号" prop="carNo"></el-table-column>
      <el-table-column align="center" label="车颜色" prop="color"></el-table-column>
      <el-table-column align="center" label="座位数" prop="seatNum" width="60"></el-table-column>
      <el-table-column align="center" label="车辆类型" prop="type"></el-table-column>
      <el-table-column align="center" label="状态" width="80">
        <template slot-scope="scope">
          <span :class="scope.row.status == '可用' ? 'green' : 'red'">{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="修改时间" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime | filterDate('yyyy-MM-dd hh:mm:ss') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <span class="blue cu-p" @click="showEdit(scope.row)">编辑</span>
          <span class="ml10 red cu-p" @click="delCar(scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>

    <el-dialog :visible.sync="isShow" :close-on-click-modal="!updataing" :close-on-press-escape="!updataing" :show-close="!updataing">
      <span class="font-16" slot="title">{{ title }}</span>
      <div class="w100">
        <table class="w100 table-view">
          <tbody>
            <tr>
              <td>车牌号<span class="red">*</span></td>
              <td>
                <el-input style="width: 200px" v-model="selData.carNo" placeholder="请输入车牌号"></el-input>
              </td>
            </tr>
            <tr>
              <td>车颜色<span class="red">*</span></td>
              <td>
                <el-input style="width: 200px" v-model="selData.color" placeholder="请输入车颜色"></el-input>
              </td>
            </tr>
            <tr>
              <td>座位数<span class="red">*</span></td>
              <td>
                <el-input-number v-model="selData.seatNum" :max="999" :min="1"></el-input-number>
              </td>
            </tr>
            <tr>
              <td>车辆类型</td>
              <td>
                <el-input style="width: 200px" v-model="selData.type" placeholder="请输入车辆类型"></el-input>
              </td>
            </tr>
            <tr>
              <td>车辆状态<span class="red">*</span></td>
              <td>
                <el-switch v-model="selData.status" active-value="enable" inactive-value="disable"></el-switch>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <span slot="footer">
        <el-button @click="isShow = false" :loading="updataing">取 消</el-button>
        <el-button type="primary" :loading="updataing" @click="cilckUpdata">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OfficeCar",
  components: {},
  props: [],
  data() {
    return {
      loading: false,

      queryKey: "",
      list: [],
      page: 1,
      size: 30,
      total: 0,

      isShow: false,
      updataing: false,
      title: "",
      selData: {
        id: "",
        carNo: "",
        color: "",
        seatNum: 1,
        type: "",
        status: "enable"
      }
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  created() {},
  mounted() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.loading = true;

      this.$http
        .post(
          "car/query",
          this.$qs.stringify({
            queryKey: "",
            pageNum: 1,
            pageSize: 30
          })
        )
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.list = data.resData.list;
            this.total = data.resData.total;
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.loading = false;
        });
    },
    cilckUpdata() {
      // console.log(this.selData);
      if (this.selData.carNo == "" || this.selData.color == "") {
        this.$message({
          message: "必填信息不能为空",
          type: "error"
        });
        return;
      }

      let url = "";
      if (this.title == "新增车辆") {
        url = "car/add";
      } else {
        url = "car/update";
      }
      this.updataing = true;
      this.$http
        .post(url, JSON.stringify(this.selData), {
          headers: {
            "Content-Type": "application/json;charset=utf-8"
          }
        })
        .then(({ data }) => {
          // console.log(data);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.$message({
              message: data.resMsg,
              type: "success"
            });
            this.fetchList();
          } else {
            this.$message({
              message: data.resMsg,
              type: "error"
            });
          }
          this.updataing = false;
          this.isShow = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.updataing = false;
          this.isShow = false;
        });
    },
    delCar(obj) {
      this.$confirm(`是否删除 ${obj.carNo}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.$http
            .post(
              "car/delete",
              JSON.stringify({
                id: obj.carNo
              }),
              {
                headers: {
                  "Content-Type": "application/json;charset=utf-8"
                }
              }
            )
            .then(({ data }) => {
              // console.log(data.resData);
              if (data.resStatus == 0 && data.resCode == 0) {
                this.$message({
                  message: data.resMsg,
                  type: "success"
                });
                this.fetchList();
              } else {
                this.$message({
                  message: data.resMsg,
                  type: "error"
                });
              }
              this.loading = false;
            })
            .catch(() => {
              this.$message({
                message: "网络请求错误，请检查网络",
                type: "error"
              });
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    showEdit(obj) {
      // console.log(obj);
      this.title = obj.carNo;
      this.selData.id = obj.id;
      this.selData.carNo = obj.carNo;
      this.selData.color = obj.color;
      this.selData.seatNum = obj.seatNum;
      this.selData.type = obj.type;
      this.selData.status = obj.status == "可用" ? "enable" : "disable";

      this.$nextTick(() => {
        this.isShow = true;
      });
    },
    showAdd() {
      this.title = "新增车辆";
      this.selData.id = "";
      this.selData.carNo = "";
      this.selData.color = "";
      this.selData.seatNum = 1;
      this.selData.type = "";
      this.selData.status = "enable";

      this.$nextTick(() => {
        this.isShow = true;
      });
    },
    changeSize(value) {
      this.size = value;
      this.fetchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    }
  },
  watch: {}
};
</script>

<style scoped>
.table-view {
  border-collapse: collapse;
}
.table-view td {
  padding: 10px;
  border: 1px solid #dddddd;
}
.table-view tr td:first-child {
  min-width: calc(5em + 20px);
  background: #efefef;
}
</style>
